/*
 * Venue map, shown from the city/region SEO pages and from a venue's space
 * list.
 *
 * This component no longer knows which mapping vendor draws the map: it hands
 * `MarkerMap` a centre, a set of markers and which one is selected, and gets
 * click events back. `VUE_APP_MAP_PROVIDER` decides the rest. See
 * docs/google-maps-to-osm.md.
 */
import ModalPopup from '@/shared/components/ModalPopup.vue';
import { computed, defineComponent, ref } from '@vue/composition-api';
import MapInfoWindowShortened from '@/Search/components/MapInfoWindowShortened.vue';
import MarkerMap from '@/shared/components/map/MarkerMap.vue';
const DEFAULT_MAP_ZOOM = 16;
const DEFAULT_MARKER_Z_INDEX = 888;
export default defineComponent({
    components: {
        ModalPopup,
        MapInfoWindowShortened,
        MarkerMap
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        venues: {
            type: Array,
            default: () => []
        }
    },
    setup(props, { emit }) {
        const onClose = () => {
            emit('close');
        };
        const zoom = ref(DEFAULT_MAP_ZOOM);
        const selectedVenueId = ref(null);
        const mapDefaultCenter = computed(() => ({
            lat: props.venues[0]?.venue_geo?.latitude,
            lng: props.venues[0]?.venue_geo?.longitude
        }));
        const mapMarkers = computed(() => props.venues.map(venue => ({
            id: venue.venue_id,
            position: {
                lat: venue.venue_geo.latitude,
                lng: venue.venue_geo.longitude
            },
            title: venue.venue_name,
            zIndex: DEFAULT_MARKER_Z_INDEX
        })));
        const selectedVenue = computed(() => props.venues.find(venue => venue.venue_id === selectedVenueId.value) ||
            null);
        const onMarkerClick = (marker) => {
            selectedVenueId.value = marker.id;
        };
        return {
            mapDefaultCenter,
            mapMarkers,
            selectedVenue,
            selectedVenueId,
            zoom,
            onClose,
            onMarkerClick
        };
    }
});
